<template lang="html">
  <div id="home-page">

    <section class="banner-section">
      <swiper class="swiper desktop" :options="bannersOptions">
        <swiper-slide v-for="(b, bhInx) in banners.pc" :key="'bhInx-'+bhInx">
          <div class="placed-backg box" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }">
            <img src="public/images/pages/home/banner.png">
          </div>
        </swiper-slide>

        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <swiper class="swiper mobile" :options="bannersOptions">
        <swiper-slide v-for="(b, bhmInx) in banners.movil" :key="'bhmInx-'+bhmInx">
          <div class="placed-backg box" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }">
            <img src="public/images/pages/home/banner-m.png">
          </div>
        </swiper-slide>

        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>

    <section class="video-section">
      <div class="container">
        <div class="box-video">
          <iframe src="https://www.youtube.com/embed/NZ0NKkyZBxc?si=ztCaYQCkbRpXCrzj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
    </section>

    <section class="services-section">
      <div class="container oversized-container">
        <div class="d-block mb-4">
          <h2 class="text-center title-s1 c-primary">Categorías</h2>
          <!-- <p>
            <router-link class="f-w-600 link-s1 redl" to="/servicios">Ver todos</router-link>
          </p> -->
        </div>

        <div class="box-services">
          <swiper class="swiper" :options="categoriesOptions">
            <swiper-slide v-for="(s, shInx) in categories" :key="'shInx-'+shInx">
              <div class="col-12 p-3 box-service-sample-1">
                <router-link class="wr" :to="'/productos/'+$root._converToURL(s.name, s.id)">
                  <div class="placed-backg box" v-bind:style="{ backgroundImage: 'url('+s.imageUrl+')' }" to="" style="background-size: contain;">
                    <!-- <div class="placed-backg box-text">
                      <h5>{{ s.name }}</h5>
                    </div> -->
                  </div>

                  <div class="box-button">
                    <div class="btn-cat" to="">
                      <span>{{ s.name }}</span>
                    </div>
                  </div>
                </router-link>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </section>

    <section class="certs-section">
      <div class="container oversized-container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-certs">
            <a target="_blank" href="https://digipris.cofepris.gob.mx/getTramite?id=hkM5uvdYpFYWOpS8%2FjHL8wHBbQVBcNL5">
              <img class="cert" src="public/images/pages/home/certi-1.png">
            </a>

            <a target="_blank" download href="public/pdfs/OFICIO_NO_COFEPRIS-0072-2024.pdf">
              <img class="cert" src="public/images/pages/home/certi-2.png">
            </a>

            <!-- <img class="cert" :src="cer.imageUrl" v-for="(cer,indx) in certificates" :key="indx"> -->
            <!-- <img class="cert" src="public/images/pages/home/cert-2.png">
            <img class="cert" src="public/images/pages/home/cert-6.png">
            <img class="cert" src="public/images/pages/home/cert-4.png">
            <img class="cert" src="public/images/pages/home/cert-5.png">
            <img class="cert" src="public/images/pages/home/cert-6.png"> -->
          </div>
        </div>
      </div>
    </section>

    <section class="products-section">
      <div class="container oversized-container">
        <div class="d-block mb-1">
          <h2 class="text-center title-s1 c-primary">Productos</h2>
        </div>

        <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
          <swiper-slide v-for="(p, pdInx) in products" :key="'pdInx-'+pdInx">
            <BoxProductComponent :css="'col-12 px-0'" :product="p"></BoxProductComponent>
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>

        <div class="d-block text-center pt-3 pb-1">
          <a class="px-4 btn btn-s1 bg-green-2 w-auto" target="_blank" :href="catalog_pdf">Descarga nuestro catálogo </a>
        </div>
      </div>
    </section>

    <GuaranteeComponent></GuaranteeComponent>
  </div>
</template>

<script>
import GuaranteeComponent from './company/guarantee-component.vue';
import BoxProductComponent from './products/box-product-component.vue';

export default {
  components: {
    GuaranteeComponent, BoxProductComponent
  },

  data() {
    return {
      banners: {
        pc:[],
        movil:[],
      },
      categories: [],
      products: [],
      certificates:[],


      // == Carousel options ==
      bannersOptions: {
        loop: true,
        speed: 700,

        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      },

      categoriesOptions: {
        slidesPerView: 4,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          1600: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },

      productsOption: {
        loop: false,
        slidesPerView: 5,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1600: {
            slidesPerView: 5,
          },
          1200: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          576: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1
          },
        }
      },
      catalog_pdf:null,
      // == ==
    }
  },
  methods:{
      getHome(){
        axios.get(tools.url("/api/home")).then((response)=>{
            this.banners=response.data.banners;
            this.categories=response.data.categories;
            this.products=response.data.products;
            this.catalog_pdf = response.data.pdf;

            this.certificates = response.data.certificates;

          }).catch((error)=>{
        });
      },
  },
  mounted(){
    this.getHome();
  }
}
</script>
